
export function autoLogin({dispatch, state}){
      
    // if active school found
    var school=state.user_schools.find(school => school.active === 1);
    
    

    if(school){
      return dispatch('login', { school } ).then(
        result=>{ 
          // success
          
          return result;
        },
        ()=>{ 
          // error logging in to school
          
          return Promise.reject();
          //return error;
        }
      )
    }else{
      // no activated login found
      return Promise.reject();
    }

  
    
  }
  
  